/**
 * Ostatnio wybrana sala — podpowiedź przy zakładaniu zajęć.
 *
 * Grafik układa się salami: przez pół dnia wpisuje się kolejne lekcje w to samo
 * pomieszczenie, a formularz za każdym razem proponował pierwszą salę z listy.
 * Pamięć jest **osobna dla każdego oddziału**, bo sale do niego należą, i żyje
 * w przeglądarce — to wygoda tej osoby przy tym komputerze, nie ustawienie
 * szkoły.
 */
const KLUCZ = 'legato:ostatnia-sala'

/** Zapisuje wybór. Cicho odpuszcza, gdy przeglądarka nie daje pamięci. */
export function zapamietajSale(locationId: string, roomId: string): void {
  if (!locationId || !roomId) return
  try {
    window.localStorage.setItem(`${KLUCZ}:${locationId}`, roomId)
  } catch {
    // Tryb prywatny albo zablokowane dane witryny — podpowiedź nie jest niczym,
    // bez czego formularz nie działa.
  }
}

/**
 * Ostatnio wybrana sala tego oddziału, o ile nadal istnieje.
 *
 * Sala mogła zostać wyłączona z użytku albo przypisana gdzie indziej —
 * dlatego zapamiętany identyfikator konfrontujemy z aktualną listą, zamiast
 * podstawiać go w ciemno.
 */
export function ostatniaSala(locationId: string, dostepne: { id: string }[]): string | null {
  if (!locationId) return null
  try {
    const zapamietana = window.localStorage.getItem(`${KLUCZ}:${locationId}`)
    return zapamietana && dostepne.some((room) => room.id === zapamietana) ? zapamietana : null
  } catch {
    return null
  }
}
